module.exports = __webpack_public_path__ + "assets/1dc35d25e61d819a9c357074014867ab.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.3
 ** module id = 1766
 ** module chunks = 1
 **/